module.exports = __webpack_public_path__ + "img/sbp_gm.e383623f.svg";